
















import { DynamicDocumentData, DynamicDocumentItem, InstallationModuleData } from "@/types";
import Vue, { PropType } from "vue";

import ExpandableItem from "./ExpandableItem.vue";

export default Vue.extend({
  components: {
    ExpandableItem
  },

  data() {
    return {
      active: -1
    };
  },

  props: {
    items: {
      type: Array as PropType<DynamicDocumentItem[]>
    },

    data: {
      type: Array as PropType<DynamicDocumentData>,
      default: () => []
    },
    moduleData: Object as PropType<InstallationModuleData>
  }
});
